import script from "./MultiItemInspectionFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiItemInspectionFormView.vue?vue&type=script&setup=true&lang=js"

import "./MultiItemInspectionFormView.vue?vue&type=style&index=0&id=11ac4a85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ac4a85"]])

export default __exports__